import { Lightbulb } from "lucide-react";

export default function CalloutCard({ bullets, ipoName }) {
  return (
    <div
      className="rounded-2xl border border-indigo-500/25 bg-gradient-to-br from-indigo-500/[0.08] to-fuchsia-500/[0.04] p-6"
      data-testid="callout-card"
    >
      <div className="flex items-center gap-2 text-indigo-300">
        <Lightbulb className="h-4 w-4" />
        <span className="font-mono-jb text-[11px] uppercase tracking-[0.18em]">Why not just wait for the {ipoName} IPO?</span>
      </div>
      <ul className="mt-4 space-y-3">
        {(bullets || []).map((b, i) => (
          <li key={i} className="flex gap-3 text-sm leading-relaxed text-zinc-200">
            <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-indigo-300" />
            <span>{b}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
